<template>
    <v-sheet tile elevation="1" height="100%" class="mt-2 pa-8">
        <v-container fluid>
            <v-row class="ma-0 pb-8 pt-4">
                <span class="main-title">Planejamento de Alojamento</span>
                <v-spacer/>
                <novo-planejamento-alojamento-dialog>
                    <template v-slot:activator="{ on }">
                        <v-btn depressed color="#2BC1B6" class="white--text" v-on="on">Criar Novo Planejamento</v-btn>
                    </template>
                </novo-planejamento-alojamento-dialog>
            </v-row>

            <transition-group tag="v-row" name="slide-fade" appear type="out">
                <v-col v-for="item in planejamentos" :key="item.idPlanejamentoAlojamento" class="five-cols">
                    <planejamento-alojamento-card :item="item" @deleted="onDeleted" @updated="onUpdated" :status-types="statusTypes"/>
                </v-col>
            </transition-group>
        </v-container>
    </v-sheet>
</template>

<script>
import PlanejamentoAlojamentoCard from "../components/PlanejamentoAlojamento/PlanejamentoAlojamentoCard";
import NovoPlanejamentoAlojamentoDialog from "../components/PlanejamentoAlojamento/NovoPlanejamentoAlojamentoDialog";

export default {
    name: "PlanejamentoAlojamento",
    components: { NovoPlanejamentoAlojamentoDialog, PlanejamentoAlojamentoCard },
    data: () => ({
        planejamentos: [],
        loading: false,
        statusTypes: []
    }),
    methods: {
        loadPlanejamentos() {
            this.loading = true
            this.$axios("planejamento-alojamento/").then(
                (res) => {
                    if (!res.data) return;
                    if (!res.data[0].data) return;

                    this.planejamentos = res.data[0].data;
                }
            )
            .catch(error => {
              this.$store.commit("setSnack", { type: "error", msg: error });
            })
            .finally(() => {
                this.loading = false
            });
        },
        loadTiposStatus() {
            this.$axios("status-planejamento-alojamento/")
                .then((res) => {
                    if (!res.data) return;
                    if (!res.data[0].data) return;

                    this.statusTypes = res.data[0].data;
                })
                .catch(error => {
                  this.$store.commit("setSnack", { type: "error", msg: error });
                })
        },
        onDeleted(item) {
            const idx = this.planejamentos.findIndex(p =>
                p.idPlanejamentoAlojamento === item['cdPlanejamentoAlojamento']
            )
            if (idx > -1) {
                this.planejamentos[idx].cdStatusPlanejamentoAlojamento = item['cdStatusPlanejamentoAlojamento']
            }
        },
        onUpdated(item) {
          const idx = this.planejamentos.findIndex(p => p.idPlanejamentoAlojamento === item.idPlanejamentoAlojamento)
          if (idx > -1) {
            this.planejamentos.splice(idx, 1, item)
          }
        },
    },
    mounted() {
        this.loadPlanejamentos()
        this.loadTiposStatus()
    },
};
</script>

<style scoped lang="scss">
.main-title {
  font: normal normal bold 24px/32px Roboto;
  letter-spacing: 0;
  color: #37565c;
  opacity: 1;
}

.five-cols {
  flex: 0 1 20% !important;
}

.slide-fade-enter-active {
  transition: all .3s ease;
}
.slide-fade-leave-active {
  transition: all .2s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to {
  transform: translateX(10px);
  opacity: 0;
}
</style>